import React from "react";
import { Dropdown, Button } from "react-bootstrap";
import { Card, DictionaryPaths } from "../../types/Common";

export default function ExternalLinksDropdown(props: {
    card: Card,
    dictionaryPaths: DictionaryPaths
}) {
    const { phraseLanguageCode, meaningLanguageCode, reversoPath, wiktionaryLanguage } = props.dictionaryPaths;
    const phrase = preparePhrase(props.card.phrase, wiktionaryLanguage);;
    const wiktionaryUrl = getWiktionaryUrl(phrase, wiktionaryLanguage);
    const reversoContextUrl = `https://context.reverso.net/translation/${reversoPath}/${phrase}`;
    const googleTranslateUrl = `https://translate.google.com/?sl=${phraseLanguageCode}&tl=${meaningLanguageCode}&text=${phrase}`;

    const options: [string, string][] = [];

    if (wiktionaryUrl)
        options.push(['Wiktionary', wiktionaryUrl])
    if (reversoContextUrl)
        options.push(['Reverso Context', reversoContextUrl])
    if (googleTranslateUrl)
        options.push(['Google Translate', googleTranslateUrl])

    return (
        <>
            {phrase &&
                <Dropdown className="d-inline-block panel-btn">
                    <Dropdown.Toggle variant="outline-primary"
                        className="btn btn-sm btn-outline-primary btn-wide" >
                        External links
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {options.map(([name, url]) =>
                            <Dropdown.Item as={Button}
                                key={name}
                                variant="outline"
                                onClick={() => soureClicked(url)}>
                                {name}
                            </Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                </Dropdown>
            }
        </>
    );
}

function soureClicked(url: string) {
    window.open(url, "_blank", "noreferrer")
}

export function getWiktionaryUrl(phrase: string, language: string | undefined) {
    if (language) {
        phrase = preparePhrase(phrase, language);
        return `https://en.wiktionary.org/wiki/${phrase}` + '#' + language.substring(0, 1).toUpperCase() + language.substring(1, language.length);
    }
}

export function preparePhrase(phrase: string, language: string | undefined,) {
    language = language?.toLowerCase();
    if (language === 'german')
        phrase = phrase.replace(/^(der|die|das) /g, '');
    if (language === 'swedish')
        phrase = phrase.replace(/^(en|ett|en\/ett) /g, '');
    else if (language === 'english')
        phrase = phrase.replace(/ (smb\/smth|smb|smth|s)/g, '');
    else if (language === 'arabic')
        phrase = phrase.replace(/(َ|ِ|ُ|ْ|ّ|ً)/g, '');
    return phrase;
}

